import type { GetServerSidePropsContext, NextPage } from 'next';

import { PartnersApiService, WebAppApiService } from 'services';

import { PagesType } from 'common/pages-type';

import Layout from '@/components/layout/layout';
import PartnerCard from '@/components/partner/partner-card';

import { IPartnerModel, IWebAppModel } from 'models';

import styles from './partners.module.scss';
import { useEffect } from 'react';
import { MixpanelTrackingService } from '@/services/mixpanel-services';

interface IPartnersPageProps {
  webApp: IWebAppModel;
  partners: IPartnerModel[];
  preview: boolean;
}

const PartnersPage: NextPage<IPartnersPageProps> = ({
  webApp,
  partners,
  preview,
}) => {
  useEffect(() => {
    MixpanelTrackingService.getInstance().pageViewed();
  }, []);

  return (
    <Layout
      preview={preview}
      origin={PagesType.Partners}
      headerImageUrl={webApp.headerImageUrl}
      logoUrl={webApp.logoUrl}
      stravaUrl={webApp.stravaUrl}
      facebookUrl={webApp.facebookUrl}
      instagramUrl={webApp.instagramUrl}
      title={webApp.siteName}
      description={webApp.description}>
      <div className={styles.container}>
        <h1>Nos partenaires</h1>
        <div className={styles.description}>
          La {webApp.siteName} est soutenu par quelques sponsors / partenaires
          que nous remercions
        </div>
        <div className={styles.partners}>
          {partners.map((p) => (
            <PartnerCard key={p.id} partner={p}></PartnerCard>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  try {
    const webAppService = new WebAppApiService();
    const webapp = await webAppService.getWebApp(context);

    const partnersService = new PartnersApiService();
    const partners = await partnersService.getAllPartners(context);

    return {
      props: {
        webApp: webapp,
        partners: partners,
        preview: context.preview ?? false,
      } as IPartnersPageProps,
    };
  } catch {
    return {
      props: {},
    };
  }
};

export default PartnersPage;
